package pl.decks.personal.components.widgets.ranks.electric

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.div
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.plus
import org.jetbrains.compose.web.css.times
import pl.decks.personal.components.widgets.ranks.RanksStylesheet
import pl.decks.personal.components.widgets.ranks.RanksStylesheet.Vars
import pl.decks.personal.components.widgets.ranks.shapes.Battery
import pl.decks.personal.components.widgets.ranks.shapes.RankLine
import pl.decks.personal.theme.SitePalette

@Composable
internal fun BatteryBadge(
    rank: BatteryRank,
    coloring: SitePalette.BatteryColors,
    strokeFraction: Float,
    capHeight: Float,
    modifier: Modifier = Modifier,
) = Box(RanksStylesheet.SlotBadge.toModifier().then(modifier), contentAlignment = Alignment.BottomCenter) {
    val stroke = strokeFraction.times(100)
    Battery(
        backgroundColor = coloring.body,
        strokeColor = coloring.stroke,
        strokeWidth = stroke,
        capHeight = capHeight,
    )
    BatteryFill(
        rank,
        coloring.fill,
        modifier = Modifier
            .fillMaxSize()
            .padding(
                // actually 8*half gap
                top = (stroke + capHeight.times(100)).percent + 5 * Vars.Insignia.lineLineRelGap.value(),
                // +1 is micro adjustment to lift it a bit more
                bottom = (stroke + 1).percent + Vars.Insignia.lineLineRelGap.value(),
                left = stroke.percent,
                right = stroke.percent,
            )
    )
}

@Composable
private fun BatteryFill(
    rank: BatteryRank,
    color: Color,
    modifier: Modifier = Modifier,
) = Column(
    Modifier
        .fillMaxSize()
        .gap(Vars.Insignia.lineLineRelGap.value() / 2)
        .then(modifier),
    horizontalAlignment = Alignment.CenterHorizontally,
) {
    val noLines = BatteryRank.entries.size - 1
    (0 until noLines).forEach { pos ->
        Box(Modifier.fillMaxWidth().weight(1f).flexShrink(0)) {
            if (pos >= noLines - rank.ordinal)
                RankLine(color, Modifier.fillMaxSize())
        }
    }
}
